import { render } from "./Passings.vue?vue&type=template&id=c2e9b172&scoped=true"
import script from "./Passings.vue?vue&type=script&lang=js"
export * from "./Passings.vue?vue&type=script&lang=js"

import "./Passings.vue?vue&type=style&index=0&id=c2e9b172&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e9b172"]])

export default __exports__